module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_7016.8d630867.png";